/* tslint:disable */
/* eslint-disable */
export enum WorkMyTaskTabKindEnum {
  General = 'general',
  Role = 'role',
  User = 'user',
  ProjectRequests = 'projectRequests',
  Todos = 'todos'
}
